import { useState, useEffect } from 'react';

/**
 * Hook that will detect what browser page is being rendered in
 * TODO: be aware chrome push for navigator.userAgentData instead of userAgent. Currently unsupported by IE, Safari, and Firefox, but we should review periodically.
 **/

function useBrowserDetect(): string {
  const [isBrowser, setIsBrowser] = useState('unknown');

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isChrome = userAgent?.match(/chrome|chromium|crios/i);
    const checkEdge = userAgent?.indexOf('Edg') !== -1;

    if (userAgent?.match(/firefox|fxios/i)) {
      setIsBrowser('firefox');
    } else if (userAgent?.match(/opr\//i)) {
      setIsBrowser('opera');
    } else if (isChrome && !checkEdge) {
      setIsBrowser('chrome');
    } else if (isChrome && checkEdge) {
      setIsBrowser('edge');
    } else if (userAgent?.match(/safari/i)) {
      setIsBrowser('safari');
    } else if (userAgent?.match(/trident/i)) {
      setIsBrowser('ie');
    }
  }, []);

  return isBrowser;
}

export default useBrowserDetect;
